import { render, staticRenderFns } from "./QuotaLines.vue?vue&type=template&id=246ebac0&"
import script from "./QuotaLines.vue?vue&type=script&lang=ts&"
export * from "./QuotaLines.vue?vue&type=script&lang=ts&"
import style0 from "./QuotaLines.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports